import common from "./common.json";
import languages from "./languages.json";
import mirageStudio from "./mirage-studio.json";

export default {
  common,
  languages,
  "mirage-studio": mirageStudio,
};
